<script setup>
import { Spinner } from '@/components/ui/spinner'
</script>

<template>
  <div class="p-8 flex flex-col items-center justify-center">
    <Spinner class="h-6 w-6 mb-2" />
    <span class="text-sm text-gray-500">Authorizing...</span>
  </div>
</template>
